import styled from 'styled-components'

export const AdvertDiv = styled.div `
    display:flex;
    flex-direction:row;
    justify-content:space-space-between;
    align-items:center;
    min-height:100px;
    justify-content:center;

    .row{
        
    }

    @media (max-width:700px){
        .row{
            display:flex;
            flex-direction:column;
           
        }
        
    }

`